/* eslint-disable standard/object-curly-even-spacing */
import Vue from 'vue'
import Router from 'vue-router'

import HomePage from '@/components/HomePage'
import NotFoundPage from '@/components/NotFoundPage'

Vue.use(Router)

export default new Router({
  routes: [
    { path: '/:dir/:lang', name: 'HomePage', component: HomePage },
    // ----------------------------------------------------------------------------------------------------- Opcje
    { path: '/404', component: NotFoundPage },
    { path: '*', redirect: '/404' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js